export const getCategoryLabel = ({
  context = null,
  landingSettings = null,
  subCategory = null,
  categories = null,
  categorySettings = null,
  subcategorySettings = null,
  currentCategorySettings = null,
  dataPath = null,
  section = null,
}) => {
  let categoryPath = null;
  let categoryLabel = null;

  // Merge categories and subcategories so the behave as one.
  let allCategories = landingSettings.categories.concat(
    landingSettings.subcategories
  );

  let routePath = context.url;

  let sectionParent =
    dataPath !== undefined && dataPath !== null
      ? allCategories.filter((item) => {
          return item.dataPath === dataPath;
        })
      : null;

  let categorySetting = categorySettings.filter((setting) => {
    // console.log("categories", categories, setting);
    return categories === setting.categories;
  });
  //   console.log("subcategorySettings", subcategorySetting);
  let subcategorySetting = subcategorySettings.filter((setting) => {
    // console.log("subCategory", subCategory, setting);
    return subCategory === setting.subCategory;
  });

  //   console.log("routeLandingCategories", routeLandingCategories);
//   console.log("categorySetting", categorySetting);
//   console.log("subcategorySetting", subcategorySetting);
  //   console.log(dataPath, "categories", categories, "subCategory", subCategory,);
//   if (sectionParent !== undefined && sectionParent !== null) {
//     // console.log("d", dataPath, routeLandingCategories[0]);

//     categorySetting = categorySettings.filter((setting) => {
//       if (sectionParent[0] !== undefined) {
//         // console.log("categories", categories, setting, sectionParent[0].categories);
//         return setting.categories === sectionParent[0].categories;
//       }
//     });
//     //   console.log("subcategorySettings", subcategorySetting);
//     subcategorySetting = subcategorySettings.filter((setting) => {
//       if (sectionParent[0] !== undefined) {
//         // console.log("subCategory", subCategory, setting, sectionParent[0].subCategory);
//         return setting.subCategory === sectionParent[0].subCategory;
//       }
//     });
//   }
  // console.log("categorySetting", categorySetting);
  // console.log("subcategorySetting", subcategorySetting);

  if (
    routePath !== "/" &&
    subcategorySetting !== null && // Has a subcategory
    subcategorySetting.length > 0
  ) {
      
    categoryPath = subcategorySetting[0].route;
    categoryLabel = subcategorySetting[0].sectionLabel;
    // console.log("has subcat", categoryPath, categoryLabel);
  } else if (categorySetting !== null && categorySetting.length > 0) {
    categoryPath = categorySetting[0].route;
    categoryLabel = categorySetting[0].sectionLabel;
    // console.log("has cat", categoryPath, categoryLabel);
  }

  return {
    categoryPath,
    categoryLabel,
  };
};
